import { SelectProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { Combobox, type ComboboxOption } from '@/components/ui/combobox'

export default function Select(props: SelectProps) {
  const {
    inputId,
    label,
    onChange,
    options,
    value,
    onFocus,
    onBlur,
    required,
    disabled
  } = props

  const comboboxOptions: ComboboxOption[] = options.map(option => ({
    label: option.label,
    value: `${option.value}`,
    prefix: option.prefix
  }))

  return (
    <InputFieldset {...props}>
      <Combobox
        options={comboboxOptions}
        value={value !== null ? `${value}` : null}
        onChange={newValue =>
          onChange(newValue !== null ? Number.parseInt(newValue, 10) : null)
        }
        id={inputId}
        aria-label={label}
        required={required}
        disabled={disabled}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </InputFieldset>
  )
}
